let types = { 1: "SKPD", 2: "SKPDKB", 3: "SKPDN" }

function getTypes(type){
    if(type){
        return types[1]
    }
    return ''
}

export default getTypes